import { useServer } from "@/lib/server-context";
import { Plus, ServerCrash } from "lucide-react";

export default function EmptyServer({ needsBot = false }) {
  const { active, botInviteUrl } = useServer();
  return (
    <div data-testid="empty-server" className="tactical-card p-10 text-center max-w-2xl mx-auto">
      <ServerCrash className="w-12 h-12 text-brand-orange mx-auto mb-4" />
      <div className="overline mb-2 text-yellow-400">// {needsBot ? "BOT NOT INSTALLED" : "NO SERVER SELECTED"}</div>
      <h2 className="font-heading text-2xl font-bold uppercase tracking-tight mb-3">
        {needsBot ? `Add the bot to ${active?.name || "your server"}` : "Select a server first"}
      </h2>
      <p className="text-zinc-400 mb-6">
        {needsBot
          ? "The 606 Bot needs to be in this server before you can use this panel."
          : "Pick one of your Discord servers from the sidebar to manage it."}
      </p>
      {needsBot && botInviteUrl && (
        <a href={botInviteUrl} target="_blank" rel="noreferrer" className="btn-primary" data-testid="empty-add-bot-btn">
          <Plus className="w-4 h-4" /> Add Bot to Server
        </a>
      )}
    </div>
  );
}
